module.exports = __webpack_public_path__ + "static/media/footer-location-web.2c3507d2.svg";